import {Dispatch} from "redux";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {Popup} from "../../../models/enums/popup";
import {SEE_POPUP_FAIL, SEE_POPUP_RESET, SEE_POPUP_START, SEE_POPUP_SUCCESS,} from "./constants";
import {seePopupRequest} from "./repository";
import {SeePopupFailAction, SeePopupResetAction, SeePopupStartAction, SeePopupSuccessAction,} from "./types";

const seePopupStartAction = (): SeePopupStartAction => {
  return {
    type: SEE_POPUP_START,
  };
}
const seePopupSuccessAction = (payload: boolean): SeePopupSuccessAction => {
  return {
    type: SEE_POPUP_SUCCESS,
    payload: payload,
  };
}
const seePopupFailAction = (error: ErrorDto): SeePopupFailAction => {
  return {
    type: SEE_POPUP_FAIL,
    error: error,
  };
}
const seePopupResetAction = (): SeePopupResetAction => {
  return {
    type: SEE_POPUP_RESET,
  };
}

export const seePopup = (popup: Popup) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(seePopupStartAction());
    await seePopupRequest(popup);
    dispatch(seePopupSuccessAction(true));
  } catch (error) {
    dispatch(seePopupFailAction(getErrorDtoFromApiError(error)));
  }
};

export const seePopupReset = () => (
  dispatch: Dispatch
) => {
  dispatch(seePopupResetAction());
};
